module.exports = __webpack_public_path__ + "img/top_xia.83b40122.svg";